<template>
  <div class="loans-pro-item">
    <van-row>
      <van-col :span="8">
        <div class="lockming-pro-icon">
            <img :src="safeItem.img" />
        </div>
      </van-col>
      <van-col :span="16">
        <p class="title">{{ safeItem.title }}</p>
        <p class="desc">
          {{ $t("lockming.locknum") }} : {{ safeItem.min_price }} - {{ safeItem.max_price }}
        </p>
        <p class="desc">{{ $t('transfer.type') }} : {{ safeItem.coin_title }}</p>
        <p class="desc">{{ $t("lockming.getforday") }} :  {{ safeItem.interest_rate.split(',')[safeItem.interest_rate.split(',').length - 1] }} %</p>
        <p class="desc">
          {{ $t("lockming.days") }} : {{ safeItem.cycle.split(',')[safeItem.cycle.split(',').length - 1] }} {{ $t("common.day") }}
        </p>
        <div style="display: none; width: 50%; margin: 15px 0">
          <van-progress :percentage="50" color="#02c289" />
        </div>
      </van-col>
    </van-row>
    <van-button
          size="small"
          class="web-btn-rise loans-application"
          @click="tolockming(safeItem.id)"
          >{{ $t("lockming.tolockming") }}</van-button
        >
  </div>
</template>

<script>
export default {
  name: "lockmingPro",
  props: ['item'],
  computed:{
    safeItem(){
      return this.item || {}
    }
  },
  methods:{
    tolockming(id){
        this.$router.push(
        {
          name: "lockming-application",
          query: {
            id: id
          },
        },
        () => {}
      );
    }
  }
};
</script>

<style>
</style>
